import { Picture } from './picture.interface.cs';

export class LogDTO {
  toneelmeesterId?: number = 0;
  performanceId?: number = 0;
  theatreMessage?: string = '';
  showMessage?: string = '';
  cleaningMessage?: string = '';
  companycallMessage?: string = '';
  otherMessage?: string = '';
  /**
   * @deprecated Legacy inline-base64 wire format. New clients send
   * `imageIds` (already-uploaded ImageFile ids) and `removedImageIds`
   * for deletions. Kept so older clients deserialise without errors;
   * never populated by the post-volume-refactor flow. Slated for
   * removal in phase 2.
   */
  pictures?: Picture[] = null;
  /** Newly-uploaded ImageFile ids to attach to the log. */
  imageIds?: number[] = [];
  /** Existing ImageFile ids the user removed during this edit. */
  removedImageIds?: number[] = [];
  status?: string = 'PUBLISHED';
  submittedById?: number = 0;
}
